import { registerSchoolCache } from './school-cache.js';

export function registerMartinusCache() {
  registerSchoolCache();
}
